module.exports = __webpack_public_path__ + "static/before-4-e0d531fa47a498edd04680079cc5ebd8.png";